import { render, staticRenderFns } from "./NewProjectView.vue?vue&type=template&id=64396ca0&scoped=true"
import script from "./NewProjectView.vue?vue&type=script&lang=ts"
export * from "./NewProjectView.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectView.vue?vue&type=style&index=0&id=64396ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64396ca0",
  null
  
)

export default component.exports